import { global, languageOptions, type SupportedLocale } from '@/i18n/index';

/**
 * Validate and convert locale string to SupportedLocale
 */
export function validateLocale(locale: string): SupportedLocale {
  const supportedLocales: SupportedLocale[] = ['en', 'fr'];
  
  if (supportedLocales.includes(locale as SupportedLocale)) {
    return locale as SupportedLocale;
  }
  
  console.warn(`Unsupported locale: ${locale}, falling back to 'fr'`);
  return 'fr';
}

export function setI18nLanguage(locale: string) {
  const validatedLocale = validateLocale(locale);
  global.locale.value = validatedLocale
  /**
   * NOTE:
   * If you need to specify the language setting for headers, such as the `fetch` API, set it here.
   * The following is an example for axios.
   *
   * axios.defaults.headers.common['Accept-Language'] = locale
   */
  document.querySelector('html')?.setAttribute('lang', locale);
}

export const getLanguageLabel = (code: string) => {
  const language = languageOptions.find((lang) => lang.value === code);
  return language ? language.label : code;
};

export function getLang(lang: string): string {
  // Handle null, undefined, or empty string
  if (!lang || typeof lang !== 'string') {
    return global.fallbackLocale.value as string; // Use fallbackLocale from i18n
  }

  // Trim whitespace and convert to lowercase
  const cleanLang = lang.trim().toLowerCase();

  // Split by hyphen and get the first part (language code)
  const parts = cleanLang.split('-');
  const languageCode = parts[0];

  // Check if the language code exists in our supported languages
  const isValidLanguage = languageOptions.some(lang => lang.value === languageCode);
  if (isValidLanguage) {
    return languageCode;
  }

  // Fallback to i18n fallbackLocale if invalid
  return global.fallbackLocale.value as string;
}

// Fonction pour détecter la langue du navigateur
export function getBrowserLocale(fallback = 'en'): string {
  const browserLang = navigator.language.split('-')[0];
  const supportedLocales = ['en', 'fr'];
  return supportedLocales.includes(browserLang) ? browserLang : fallback;
}
